import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from "handlebars";


Snappy.Component.LoginPromptInitiator = class LoginPromptInitiator extends Snappy.BaseComponent {
    static get tagName() {
        return 'login-prompt-initiator';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        this.prepareContent();

    }

    setVars() {
        this.$document = $(document);
        this.trigger = this.$element.find('.js-login-prompt-initiator-trigger');
        this.baseUrl = this.$element.data('login-prompt-initiator-base');
    }

    setEventListeners() {
        this.$window.on('loginPrompt:open', this.onOpenEvent.bind(this));
        this.trigger.on('click', this.open.bind(this));

    }

    onOpenEvent() {
        this.open();
    }

    open() {
        this.$window.trigger('modal:openModal', {
            $view: this.$content,
            unclosable: true,
            unclosableBase: this.baseUrl
        });
    }

    prepareContent() {
        const templateSource = $('#prompt-login-template').html();
        const templateFiunc = Handlebars.compile(templateSource);
        const htmlString = templateFiunc({});
        this.$content = $(htmlString);
    }




};



// WEBPACK FOOTER //
// ./components/login-prompt-initiator/scripts/login-prompt-initiator.js